<template>
  <div>
    <slot :toggle="toggle" :open="isOpened" />

    <portal to="overlay-modals">
      <div v-show="isOpened" class="fixed inset-0 bg-black bg-opacity-80 z-50">
        <div class="overflow-auto" style="padding-top: 12vh; padding-bottom: 8vh; height: 100vh">
          <div class="flex justify-center">
            <div
              class="feedback-modal-width contact-form feedback-form px-8 pb-8 pt-6 rounded-lg bg-white"
            >
              <div class="flex justify-end mb-4">
                <button @click="toggle">
                  <CloseIcon class="hover:opacity-80" />
                </button>
              </div>
              <span class="text-green-primary text-xl md:text-2xl font-bold mb-3">
                Share your feedback!</span
              >
              <div class="text-almost-black mb-6 text-sm sm:text-base">
                Your feedback helps us improve. Let us know what's working and what’s not!
              </div>
              <slot name="feedback" />
            </div>
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
// import { VueFinalModal } from 'vue-final-modal';
// import Vue from 'vue';
import CloseIcon from './CloseIcon.vue';
export default {
  components: { CloseIcon },
  props: {
    open: { required: false, type: Boolean, default: false },
  },
  data() {
    return {
      isOpened: this.expanded,
    };
  },
  methods: {
    toggle() {
      this.isOpened = !this.isOpened;
      this.isOpened
        ? (document.body.style.overflow = 'hidden')
        : [(document.body.style.overflow = 'unset')];
    },
  },
};
</script>
<style>
.feedback-modal-width {
  width: 280px;
  @screen sm {
    width: 480px;
  }
}
.bottom-displacement {
  bottom: 30rem !important;
  @screen sm {
    bottom: 20rem !important;
  }
  @screen md {
    bottom: 16rem !important;
  }
  @screen lg {
    bottom: 13rem !important;
  }
  @screen xl {
    bottom: 11rem !important;
  }
}
</style>
